import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import ApiService from 'services/api';

import Storage from 'utils/storage';

import {
  LOGIN,
  LOGOUT,
  CREATE_MEMBER,
  FETCH_MEMBERS,
  FETCH_MEMBER,
  UPDATE_MEMBER,
  DELETE_MEMBER,
  setLoadedUser,
  setMembers,
  setMember,
  CREATE_COURSE,
  FETCH_COURSES,
  FETCH_COURSE,
  setCourses,
  UPDATE_COURSE,
  DELETE_COURSE,
  setLoginError,
  addNewCourse,
} from './actions';

function* loginWatcher() {
  yield takeLatest(LOGIN, loginSaga);
}

export function* loginSaga({ payload }) {
  try {
    const { member } = yield call(ApiService.login, payload);
    const { auth, ...rest } = member;
    yield put(setLoginError(null));

    yield call(Storage.auth.setAuthToken, auth.accessToken);
    yield call(Storage.user.setUserInfo, JSON.stringify(rest));
    yield put(setLoadedUser(rest));
  } catch (error) {
    yield put(
      setLoginError(
        'Unable to log in. Please check the email and password again!'
      )
    );
  }
}

function* logoutWatcher() {
  yield takeLatest(LOGOUT, logoutSaga);
}

export function* logoutSaga() {
  try {
    yield call(ApiService.logout);

    yield call(Storage.auth.removeAuthToken);
    yield call(Storage.user.removeUserInfo);
    window.location.href = '/login';
  } catch (error) {}
}

function* createMemberWatcher() {
  yield takeLatest(CREATE_MEMBER, createMemberSaga);
}

export function* createMemberSaga({ payload }) {
  try {
    yield call(ApiService.createMember, payload);
  } catch (error) {}
}

function* fetchMembersWatcher() {
  yield takeLatest(FETCH_MEMBERS, fetchMembersSaga);
}

export function* fetchMembersSaga() {
  try {
    const members = yield call(ApiService.fetchMembers);
    yield put(setMembers(members));
  } catch (error) {}
}

function* fetchMemberWatcher() {
  yield takeLatest(FETCH_MEMBER, fetchMemberSaga);
}

export function* fetchMemberSaga({ payload }) {
  try {
    const member = yield call(ApiService.fetchMember, payload);
    yield put(setMember(member));
  } catch (error) {}
}

function* updateMemberWatcher() {
  yield takeLatest(UPDATE_MEMBER, updateMemberSaga);
}

export function* updateMemberSaga({ payload }) {
  try {
    yield call(ApiService.updateMember, payload);
  } catch (error) {}
}

function* deleteMemberWatcher() {
  yield takeLatest(DELETE_MEMBER, deleteMemberSaga);
}

export function* deleteMemberSaga({ payload }) {
  try {
    yield call(ApiService.deleteMember, payload);
  } catch (error) {}
}

// Course
function* createCourseWatcher() {
  yield takeLatest(CREATE_COURSE, createCourseSaga);
}

export function* createCourseSaga({ payload }) {
  try {
    const course = yield call(ApiService.createCourse, payload);
    yield put(addNewCourse(course));
  } catch (error) {}
}

function* fetchCoursesWatcher() {
  yield takeLatest(FETCH_COURSES, fetchCoursesSaga);
}

export function* fetchCoursesSaga() {
  try {
    const courses = yield call(ApiService.fetchCourses);
    yield put(setCourses(courses));
  } catch (error) {}
}

function* fetchCourseWatcher() {
  yield takeLatest(FETCH_COURSE, fetchCourseSaga);
}

export function* fetchCourseSaga({ payload }) {
  try {
    const course = yield call(ApiService.fetchCourse, payload);
  } catch (error) {}
}

function* updateCourseWatcher() {
  yield takeLatest(UPDATE_COURSE, updateCourseSaga);
}

export function* updateCourseSaga({ payload }) {
  try {
    yield call(ApiService.updateCourse, payload);
  } catch (error) {}
}

function* deleteCourseWatcher() {
  yield takeLatest(DELETE_COURSE, deleteCourseSaga);
}

export function* deleteCourseSaga({ payload }) {
  try {
    yield call(ApiService.deleteCourse, payload);
  } catch (error) {}
}

export default function* rootSaga() {
  yield all([
    fork(loginWatcher),
    fork(logoutWatcher),
    fork(createMemberWatcher),
    fork(fetchMembersWatcher),
    fork(fetchMemberWatcher),
    fork(updateMemberWatcher),
    fork(deleteMemberWatcher),
    //Course
    fork(createCourseWatcher),
    fork(fetchCoursesWatcher),
    fork(fetchCourseWatcher),
    fork(updateCourseWatcher),
    fork(deleteCourseWatcher),
  ]);
}
